var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16647 16.0286C4.32481 16.0286 4.48314 15.9703 4.60814 15.8453L16.2748 4.1786C16.5165 3.93693 16.5165 3.53693 16.2748 3.29526C16.0331 3.0536 15.6331 3.0536 15.3915 3.29526L3.72481 14.9619C3.48314 15.2036 3.48314 15.6036 3.72481 15.8453C3.84981 15.9703 4.00814 16.0286 4.16647 16.0286Z",
    fill: "#070519"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 12.9204C16.1752 12.9204 16.4585 12.6371 16.4585 12.2954V3.73706C16.4585 3.39539 16.1752 3.11206 15.8335 3.11206H7.27516C6.9335 3.11206 6.65016 3.39539 6.65016 3.73706C6.65016 4.07873 6.9335 4.36206 7.27516 4.36206H15.2085V12.2954C15.2085 12.6371 15.4918 12.9204 15.8335 12.9204Z",
    fill: "#070519"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/arrow_up_right.cb4c0163388577979bcd59fd6d01a17d.svg";
export { ForwardRef as ReactComponent };